
import {Vue, Component, Emit, Prop} from 'vue-property-decorator';

import {classesApi, accountApi, userApi} from '@/api';

@Component
export default class Teacher_Authorize extends Vue {
    @Prop({default: {}}) authorizeTeacher?: any;
    @Emit('closeModal') private closeModal() {}
    @Emit('refreshTeacherList') private refreshTeacherList() {}
    //===================================data区域begin
    // 搜索课程名称
    isSearch: boolean = false;
    isSearchValue: string = '';
    schoolId: string = '';
    // teacherId: string = '';
    pager: any = {
        classList: {
            pagesize: 200,
            pagenum: 1,
            total: 0,
            rows: []
        },
        courseList: {
            pagesize: 200,
            pagenum: 1,
            total: 0,
            rows: []
        },
        searchCourseList: {
            rows: []
        }
    };
    urlQueryParmas: any = {
        courseName: '',
        classId: '',
        pagesize: ''
    };
    // 班级列表loading
    classLoading: boolean = false;
    // 课程列表是否为空
    courseEmpty: boolean = false;
    isfirstLoadClass: boolean = true;
    courseLoading: boolean = false;
    // 搜索列表loading
    courseSearchLoading: boolean = false;
    // 当前选中的班级
    classId: string = '';
    className: string = '';
    // 课程表单表头
    columnsCourse: any = [
        {
            dataIndex: 'courseName',
            title: '课程名称',
            scopedSlots: {
                customRender: 'courseName'
            }
        }
    ];
    // 搜索课程表单表头
    columnsSearchCourse: any = [
        {
            dataIndex: 'className',
            title: '班级名称',
            scopedSlots: {
                customRender: 'className'
            }
        },
        {
            dataIndex: 'courseName',
            title: '课程名称',
            scopedSlots: {
                customRender: 'courseName'
            }
        }
    ];
    // 表格多选框选中的key
    selectedRowKeys: any = [];
    // 选中的班级数据
    selectClassItem: any = [];
    // 选中的课程数据
    selectCourseItem: any = [];
    // 处理的班级课程数据（用于右侧回显）
    classCourseList: any = [];
    // 搜索表格滚动对象数据
    scroll: any = {
        y: 538
    };
    // 表格滚动对象数据
    scrollTable: any = {
        y: 538
    };
    // 当前教师课程的标识id（用于表格中判断多选框回显）
    teacherIndexIdList: any = [];
    //===================================data区域end

    //===================================computed区域begin
    get teacherId() {
        return this.authorizeTeacher._id;
    }
    get rowSelection() {
        return {
            //onChange方法，rowSelection改变时触发
            onChange: (selectedRowKeys: any) => {
                //     //获取选中行的key元素，和下面selectedRowKeys属性配合使用，表示给rowSelection绑定一个v-model，为this.selectedRowKeys
                this.selectedRowKeys = [...new Set(selectedRowKeys)];
                // console.log(selectedRowKeys);
                this.$nextTick(() => {
                    this.formatClassCourseList();
                });
            },
            selectedRowKeys: this.selectedRowKeys,
            onSelect: (record: any, selected: boolean, selectedRows: any) => {
                // console.log(record);
                // 搜索课程时，把选择的classId存下来
                this.classId = record.classId;
                if (selected) {
                    if (!this.selectClassItem.includes(this.classId)) {
                        this.selectClassItem.push(this.classId);
                    }
                    this.selectCourseItem.push(record);
                }
                if (!selected) {
                    for (let i = 0; i < this.selectCourseItem.length; i++) {
                        if (record.courseId == this.selectCourseItem[i].courseId && record.classId == this.selectCourseItem[i].classId) {
                            // console.log(record);
                            if (!record.isMyAuthorized) {
                                this.selectCourseItem.splice(i, 1);
                            }
                            // 表格复选框内取消已授权的课程时，调用接口取消授权
                            for (let k = 0; k < record.teachers.length; k++) {
                                if (record.teachers[k].teacherId == this.teacherId && record.teachers[k].classId == this.classId) {
                                    let itemCourse = {
                                        classId: record.classId,
                                        courseId: record.courseId
                                    };
                                    this.selectedRowKeys.push(record.indexId);
                                    this.unAuthorizeClass(itemCourse);
                                    // console.log(record);
                                    // console.log(this.selectedRowKeys);
                                }
                            }
                        }
                        for (let j = 0; j < this.selectClassItem.length; j++) {
                            if (record.classId == this.selectClassItem[j] && !this.selectCourseItem[i]?.classId == record.classId) {
                                for (let k = 0; k < record.teachers.length; k++) {
                                    if (record.teachers[k].teacherId == this.teacherId && record.teachers[k].classId == this.classId) {
                                        let itemCourse = {
                                            classId: record.classId,
                                            courseId: record.courseId
                                        };
                                        this.selectedRowKeys.push(record.indexId);
                                        this.unAuthorizeClass(itemCourse);
                                    } else {
                                        this.selectClassItem.splice(j, 1);
                                    }
                                }
                            }
                        }
                    }
                    if (this.selectCourseItem.length == 0) {
                        this.selectClassItem = [];
                    }
                }
                // console.log(this.selectClassItem, this.selectCourseItem);
            },
            // 用户手动选择/取消选择所有列的回调
            onSelectAll: (selected: boolean, selectedRows: any, changeRows: any) => {
                if (selected) {
                    for (let i = 0; i < selectedRows.length; i++) {
                        if (!this.selectClassItem.includes(selectedRows[i].classId)) {
                            this.selectClassItem.push(selectedRows[i].classId);
                        }
                    }
                    if (!this.selectClassItem.includes(this.classId)) {
                        this.selectClassItem.push(this.classId);
                    }
                    changeRows.forEach((el: any) => {
                        this.selectCourseItem.push(el);
                    });
                } else {
                    // console.log(changeRows);
                    for (let i = 0; i < changeRows.length; i++) {
                        this.selectedRowKeys.push(changeRows[i].indexId);
                        for (let j = 0; j < this.selectCourseItem.length; j++) {
                            if (this.selectCourseItem[j].indexId == changeRows[i].indexId) {
                                if (
                                    changeRows[i].hasOwnProperty('teacherId') &&
                                    changeRows[i].isMyAuthorized &&
                                    this.teacherId == changeRows[i].teacherId
                                ) {
                                    // 批量取消已授权课程
                                    if (changeRows[i].teacherId == this.teacherId) {
                                        let itemCourse = {
                                            classId: changeRows[i].classId,
                                            courseId: changeRows[i].courseId
                                        };
                                        // console.log(itemCourse);
                                        this.unAuthorizeClass(itemCourse);
                                    }
                                } else {
                                    this.selectCourseItem.splice(j, 1);
                                    for (let k = 0; k < this.selectedRowKeys.length; k++) {
                                        if (this.selectedRowKeys[k] == changeRows[i].indexId) {
                                            this.selectedRowKeys.splice(k, 1);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    // for (let k = 0; k < this.selectClassItem.length; k++) {
                    //     if (changeRows[0].classId == this.selectClassItem[k]) {
                    //         this.selectClassItem.splice(k, 1);
                    //     }
                    // }
                }
                // console.log(this.selectClassItem, this.selectCourseItem);
            },
            // 表格默认状态
            getCheckboxProps: (record: any) => ({
                props: {
                    disabled: record.showTip || record.isMyAuthorized ? true : false,
                    defaultChecked: record.showTip || record.teacherId == this.teacherId ? true : false
                }
            })
        };
    }
    //===================================computed区域end

    //===================================methods区域begin
    // 处理选中的班级，课程数据，在右侧回显
    formatClassCourseList() {
        this.classCourseList = [];
        // console.log(this.selectCourseItem);
        for (let i = 0; i < this.selectClassItem.length; i++) {
            this.classCourseList[i] = {classId: this.selectClassItem[i], className: '', course: []};
            for (let j = 0; j < this.selectCourseItem.length; j++) {
                if (this.selectCourseItem[j].classId == this.classCourseList[i].classId) {
                    this.classCourseList[i].course.push(this.selectCourseItem[j]);
                    this.classCourseList[i].className = this.selectCourseItem[j].className;
                }
            }
        }
        // console.log(this.classCourseList);
    }
    // 处理表格滚动
    scrollOrNot() {
        this.$nextTick(() => {
            // console.log(document.querySelectorAll('.ant-table-body')[2].clientHeight);
            let heightSearch = document.querySelectorAll('.ant-table-body')[1]?.clientHeight;
            let height = document.querySelectorAll('.ant-table-body')[2]?.clientHeight;
            if (heightSearch < 538) {
                this.scroll = {};
            } else {
                this.scroll = {
                    y: 538
                };
            }
            if (height < 538) {
                this.scrollTable = {};
            } else {
                this.scrollTable = {
                    y: 538
                };
            }
        });
    }
    jump(flag: any) {
        // console.log(flag, this.classId, this.className);
        if (flag == 'classManage') {
            let routeUrl = this.$router.resolve({
                path: '/school/classes/classes_manage'
            });
            window.open(routeUrl.href, 'classes_manage');
        } else if (flag == 'targetClassManage') {
            let routeUrl = this.$router.resolve({
                path: '/school/classes/class_authorize',
                query: {
                    classId: this.classId,
                    className: this.className
                }
            });
            window.open(routeUrl.href, 'class_authorize');
        }
    }
    // 刷新班级
    refreshClass() {
        this.getClassList();
    }
    // 刷新课程
    refreshCourse() {
        let item = null;
        this.checkClass(item);
    }
    checkClass(item: any) {
        let me = this;
        me.courseLoading = true;
        if (item) {
            me.classId = item._id;
            me.className = item.name;
            let classList = me.pager.classList.rows;
            for (let i = 0; i < classList.length; i++) {
                classList[i].isChecked = false;
                if (item._id == classList[i]._id) {
                    classList[i].isChecked = true;
                }
            }
            me.$forceUpdate();
        }
        me.urlQueryParmas = {
            courseName: me.isSearchValue,
            classId: me.classId,
            pagesize: me.pager.courseList.pagesize
        };
        if (me.isSearch) {
            delete me.urlQueryParmas.classId;
        } else {
            delete me.urlQueryParmas.courseName;
        }
        accountApi.requestInitCourse({
            context: me,
            urlQueryParmas: me.urlQueryParmas,
            success(data: any, parameters: any) {
                // console.log(data);
                for (let i = 0; i < data.length; i++) {
                    data[i].isMyAuthorized = false;
                    data[i].indexId = data[i].classId + '.' + data[i].courseId;
                    for (let j = 0; j < data[i].teachers.length; j++) {
                        if (data[i].teachers[j].teacherId != me.teacherId && data[i].teachers[j].classId == data[i].classId) {
                            data[i].teacher = data[i].teachers[j].nickname;
                            data[i].teacherId = data[i].teachers[j].teacherId;
                            data[i].showTip = true;
                        }
                        if (data[i].teachers[j].classId == me.classId && data[i].teachers[j].teacherId == me.teacherId) {
                            data[i].isMyAuthorized = true;
                        }
                    }
                }
                if (!me.isSearch) {
                    if (data.length == 0) {
                        me.courseEmpty = true;
                    }
                    me.pager.courseList.rows = data;
                } else {
                    if (data.length == 0) {
                        me.courseSearchLoading = true;
                    }
                    me.pager.searchCourseList.rows = data;
                }
                me.courseLoading = false;
                me.scrollOrNot();
            },
            error(error: any, message: string, parameters: any) {
                me.$message.error(message);
                me.pager.courseList.rows = [];
                me.pager.searchCourseList.rows = [];
                me.courseEmpty = true;
                me.courseLoading = false;
            }
        });
    }
    getClassList() {
        let me = this;
        me.classLoading = true;
        me.pager.classList.rows = [];
        let urlQueryParmas = {
            schoolId: me.schoolId
            // sort: '-weight'
        };
        classesApi.getClass({
            context: me,
            urlQueryParmas: urlQueryParmas,
            success(data: any, parameters: any) {
                // console.log(data);
                let dataList = data.data;
                if (dataList.length > 0) {
                    dataList[0]['isChecked'] = true;
                    for (let i = 1; i < dataList.length; i++) {
                        dataList[i]['isChecked'] = false;
                    }
                }
                me.pager.classList.rows = dataList;
                me.isfirstLoadClass = false;
                me.classLoading = false;
                me.getFirstBookList();
            },
            error(error: any, message: string, parameters: any) {
                me.$message.error(message);
                me.isfirstLoadClass = false;
                me.classLoading = false;
            }
        });
    }
    getFirstBookList() {
        let me = this;
        me.classLoading = true;
        if (me.pager.classList.rows.length > 0) {
            me.classId = me.pager.classList.rows[0]._id;
            me.className = me.pager.classList.rows[0].name;
            let urlQueryParmas = {
                classId: me.classId,
                pagesize: me.pager.courseList.pagesize
            };
            accountApi.requestInitCourse({
                context: me,
                urlQueryParmas: urlQueryParmas,
                success(data: any, parameters: any) {
                    // console.log(me.classId, me.teacherId);
                    // console.log(data);
                    for (let i = 0; i < data.length; i++) {
                        data[i].isMyAuthorized = false;
                        data[i].indexId = data[i].classId + '.' + data[i].courseId;
                        for (let j = 0; j < data[i].teachers.length; j++) {
                            if (data[i].teachers[j].teacherId != me.teacherId && data[i].teachers[j].classId == data[i].classId) {
                                data[i].teacher = data[i].teachers[j].nickname;
                                data[i].teacherId = data[i].teachers[j].teacherId;
                                data[i].showTip = true;
                            }

                            if (data[i].teachers[j].classId == me.classId && data[i].teachers[j].teacherId == me.teacherId) {
                                data[i].isMyAuthorized = true;
                            }
                        }
                    }
                    if (data.length == 0) {
                        me.courseEmpty = true;
                    }
                    me.pager.courseList.rows = data;
                    me.scrollOrNot();
                    me.classLoading = false;
                },
                error(error: any, message: string, parameters: any) {
                    me.$message.error(message);
                    me.pager.courseList.rows = [];
                    me.courseEmpty = true;
                    me.classLoading = false;
                }
            });
        } else {
            me.classLoading = false;
        }
    }
    getBookList(value: any) {
        if (value) {
            this.isSearch = true;
            this.isSearchValue = value;
            this.checkClass([]);
        } else {
            this.isSearch = false;
            this.isSearchValue = '';
            this.pager.searchCourseList.rows = [];
            this.getClassList();
            this.getFirstBookList();
        }
    }
    // 右侧取消课程
    onCancel(itemCourse: any) {
        // console.log(itemCourse);
        if (itemCourse.isMyAuthorized) {
            this.unAuthorizeClass(itemCourse);
            return;
        }
        for (let i = 0; i < this.selectedRowKeys.length; i++) {
            if (itemCourse.indexId == this.selectedRowKeys[i]) {
                this.selectedRowKeys.splice(i, 1);
            }
        }
        for (let j = 0; j < this.classCourseList.length; j++) {
            for (let k = 0; k < this.classCourseList[j].course?.length; k++) {
                if (
                    itemCourse.classId == this.classCourseList[j].classId &&
                    itemCourse.courseId == this.classCourseList[j].course[k].courseId
                ) {
                    this.classCourseList[j].course.splice(k, 1);
                    for (let l = 0; l < this.selectCourseItem.length; l++) {
                        if (this.selectCourseItem[l].indexId == itemCourse.indexId) {
                            this.selectCourseItem.splice(l, 1);
                        }
                    }

                    if (this.classCourseList[j].course.length == 0) {
                        for (let m = 0; m < this.selectClassItem.length; m++) {
                            if (this.classCourseList[j].classId == this.selectClassItem[m]) {
                                this.classCourseList[j] = [];
                                this.selectClassItem.splice(m, 1);
                            }
                        }
                    }
                }
            }
        }
        this.formatClassCourseList();
        // console.log(this.selectCourseItem);
        // console.log(this.classCourseList);
    }
    // 取消已授权课程时调用接口
    unAuthorizeClass(itemCourse: any) {
        let me = this;
        me.$confirm({
            title: '提示',
            content: '取消课程会取消与该教师的关联，请谨慎操作。',
            centered: true,
            onOk() {
                let data = {
                    classId: itemCourse.classId,
                    courseId: itemCourse.courseId,
                    teacherId: me.teacherId
                };
                classesApi.deleteTeacherInClass({
                    context: me,
                    data: data,
                    success(data: any, parameters: any) {
                        // console.log(itemCourse);
                        let itemIndexId = itemCourse.classId + '.' + itemCourse.courseId;
                        for (let i = 0; i < me.selectedRowKeys.length; i++) {
                            if (itemIndexId == me.selectedRowKeys[i]) {
                                me.selectedRowKeys.splice(i, 1);
                                // console.log(itemCourse);
                            }
                        }
                        // console.log(me.classCourseList);

                        for (let j = 0; j < me.classCourseList.length; j++) {
                            for (let k = 0; k < me.classCourseList[j].course?.length; k++) {
                                if (
                                    itemCourse.classId == me.classCourseList[j].classId &&
                                    itemCourse.courseId == me.classCourseList[j].course[k].courseId
                                ) {
                                    // console.log(itemCourse.courseId, me.classCourseList[j].course[k].courseId);
                                    for (let l = 0; l < me.selectCourseItem.length; l++) {
                                        if (
                                            me.selectCourseItem[l].courseId == itemCourse.courseId &&
                                            me.selectCourseItem[l].classId == itemCourse.classId
                                        ) {
                                            me.selectCourseItem.splice(l, 1);
                                        }
                                    }

                                    if (me.classCourseList[j].course.length == 0) {
                                        for (let i = 0; i < me.selectClassItem.length; i++) {
                                            if (itemCourse.classId == me.selectClassItem[i]) {
                                                me.selectClassItem.splice(i, 1);
                                            }
                                        }
                                        me.classCourseList[j] = [];
                                    }
                                    // console.log(me.selectClassItem);
                                }
                            }
                        }
                        me.refreshCourse();
                        me.formatClassCourseList();
                        me.$emit('refreshTeacherList');
                        me.$message.success('操作成功！该课程已取消关联。');
                    },
                    error(error: any, message: string, parameters: any) {
                        me.$message.error('操作失败！该课程正在上课中，暂时无法取消关联。');
                        return;
                    }
                });
            },
            onCancel() {}
        });
    }
    // 清空表单数据
    refreshForm() {}
    handleCancel() {
        this.refreshForm();
        this.$emit('closeModal');
    }
    handleOk() {
        // console.log(this.selectCourseItem);
        let dataList = JSON.parse(JSON.stringify(this.selectCourseItem));
        let data: any = {
            addClassCourses: []
        };
        // 处理已经授权的课程
        dataList.map((el: any) => {
            data.addClassCourses.push(
                Object.assign(
                    {},
                    {isMyAuthorized: el.isMyAuthorized, courseId: el.courseId, classId: el.classId, teacherId: this.teacherId}
                )
            );
            if (el.isMyAuthorized) {
                data.addClassCourses.splice(el, 1);
            }
        });
        if (data.addClassCourses.length == 0) {
            this.$message.error('当前未选中新课程');
            return;
        }
        if (this.teacherId == 'undefined') {
            this.$message.error('教师Id不存在！');
            this.handleCancel();
            return;
        }
        data.addClassCourses.forEach((el: any) => {
            delete el.isMyAuthorized;
        });
        // console.log(data.addClassCourses);
        let me = this;
        accountApi.authorizeTeacher({
            context: me,
            data: data,
            success(data: any, parameters: any) {
                me.$message.success('恭喜你，操作成功！');
                me.$emit('refreshTeacherList');
                me.handleCancel();
            },
            error(error: any, message: string, parameters: any) {
                me.$message.error(message);
            }
        });
    }
    getTeacherCourseList() {
        let me = this;
        let urlParamObj = {
            teacherId: me.teacherId
        };
        userApi.getTeacherClassCourse({
            urlParams: urlParamObj,
            success(data: any, parameters: any) {
                if (data.data.list[0]) {
                    me.teacherIndexIdList = [];
                    let dataList = data.data.list[0].courseClassData;
                    for (let i = 0; i < dataList.length; i++) {
                        dataList[i].isMyAuthorized = true;
                        dataList[i].indexId = dataList[i].classId + '.' + dataList[i].courseId;
                        me.selectedRowKeys.push(dataList[i].indexId);
                        me.selectCourseItem.push(dataList[i]);
                        if (!me.selectClassItem.includes(dataList[i].classId)) {
                            me.selectClassItem.push(dataList[i].classId);
                        }
                        me.teacherIndexIdList.push(dataList[i].indexId);
                    }
                    // console.log(dataList);

                    me.$nextTick(() => {
                        me.formatClassCourseList();
                    });
                }
            },
            error(error: any, message: any, parameters: any) {
                me.$message.error(message);
            }
        });
    }
    //===================================methods区域end

    created() {
        // console.log(this);
        // console.log(this.authorizeTeacher);
        if (this.authorizeTeacher) {
            this.schoolId = this.authorizeTeacher.schoolId;
        }

        this.getClassList();
        this.getTeacherCourseList();
    }
}
